import React from "react";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import SadLogo from "../components/img/figure_taiiku_suwari_back.png";

const StyledImg = styled("img")(({ theme }) => ({
  maxWidth: "100%",
  objectFit: "cover",
}));

export default function NoItemFound() {
  return (
    <Container maxWidth="sm">
      <Box sx={{
        width: "100%",
        maxWidth: 500,
        my: { xs: 20, md: 15 },
        mx: 0,
      }}>
        <StyledImg
          alt="Sorry"
          src={SadLogo}
        />
        <Typography sx={{ mt: 2 }} variant="subtitle1" gutterBottom>
            The List is Empty
        </Typography>
        <Typography variant="body1" gutterBottom>
            <Link href="/" color="inherit" underline="hover">
            Back to Home
            </Link>
        </Typography>
      </Box>
    </Container>
  );};